import { eDotDanhGiaLopActionTypeDefine } from "../../action-types/danh-gia/IDotDanhGiaLopActionType";
import { generateActions } from "../generateActions";

export const dotDanhGiaLopActions = {
    ...generateActions(eDotDanhGiaLopActionTypeDefine, "DOT_DANH_GIA_LOP"),
    

}